import { getFirestore } from '../../system/firebase';

import { SNACK_BAR_MESSAGE_OPERATION_FAILED } from '../constants';
import { convertFirebaseTimestampsToDate } from '../dateHelper';
import { deleteEmptyFields } from '../dtoHelper';

export const submitContactUsForm = async ({ data, userId, setSnackbarMessage, setSnackbarErrorMessage, setformSubmitted }) => {
    const db = getFirestore();
    const now = new Date();

    try {
        const contactUsFormDto = deleteEmptyFields({ ...data, createDt: now, createUserId: userId });
        await db.collection('contactUsForms').doc().set(contactUsFormDto, { merge: true });
        setSnackbarMessage('Feedback sent successfully!');
        setformSubmitted(true);
    } catch (error) {
        console.log(error);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
    }
};

export const submitAddToWaitlistForm = async ({ data, setSnackbarMessage, setSnackbarErrorMessage, setFormSubmitted }) => {
    const db = getFirestore();
    const now = new Date();

    try {
        const waitlistDto = deleteEmptyFields({ ...data, createDt: now });
        await db.collection('waitList').doc().set(waitlistDto, { merge: true });
        setSnackbarMessage('Congrats, You have been added to our waitlist!');
        setFormSubmitted(true);
    } catch (error) {
        console.log(error);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
    }
};

export const saveSurvey = async ({ surveyDocId, data, userId, userType, setSnackbarMessage, setSnackbarErrorMessage }) => {
    const db = getFirestore();
    const now = new Date();

    try {
        const surveyDocRef = db.collection('surveys').doc(surveyDocId);
        const surveyDoc = await surveyDocRef.get();
        if (surveyDoc.exists) {
            const surveyDto = deleteEmptyFields({ ...data, updateDt: now, userId, userType });
            await surveyDocRef.set(surveyDto, { merge: true });
            setSnackbarMessage('Feedback sent successfully!');
            return true;
        } else {
            setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
            return false;
        }
    } catch (error) {
        console.log(error);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        return false;
    }
};

export const getUserTypeFromSurvey = async ({ surveyDocId, setUserType }) => {
    const db = getFirestore();

    try {
        const surveyDocSnapShot = await db.collection('surveys').doc(surveyDocId).get();
        if (surveyDocSnapShot.exists) {
            const surveyDocData = convertFirebaseTimestampsToDate(surveyDocSnapShot.data(), ['createDt', 'emailDt', 'updateDt']);
            const { userType } = surveyDocData;
            setUserType(userType);
        }
    } catch (error) {
        console.log(error);
    }
};

export const fetchSurveyDataById = async ({ surveyDocId }) => {
    const db = getFirestore();

    try {
        const surveyDocSnapShot = await db.collection('surveys').doc(surveyDocId).get();
        if (surveyDocSnapShot.exists) {
            const surveyDocData = convertFirebaseTimestampsToDate(surveyDocSnapShot.data(), ['createDt', 'emailDt', 'updateDt']);
            return surveyDocData;
        } else {
            return null;
        }
    } catch (error) {
        console.log(error);
    }
};

export const submitSummerIntershipEmployerRegistrationForm = async ({ data, userId, setSnackbarMessage, setSnackbarErrorMessage, setFormSubmitted }) => {
    const db = getFirestore();
    const now = new Date();

    try {
        const formDto = deleteEmptyFields({ ...data, createDt: now, createUserId: userId });
        await db.collection('internProgramEmployerContacts').doc().set(formDto, { merge: true });
        setFormSubmitted && setFormSubmitted(true);
        setSnackbarMessage('Summer Internship Program Employer Registration submitted successfully!');
        return true;
    } catch (error) {
        console.log(error);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        return false;
    }
};
